<template>
  <v-combobox
    ref="combobox"
    :items="searchResult.items"
    :search-input.sync="searchFor"
    :loading="loading"
    :item-text="itemText"
    :item-value="itemValue"
    v-model="selectedItem"
    :label="label"
  ></v-combobox>
</template>
<script>
import api from "@/api";
export default {
  props: ["itemText", "itemValue", "label", "searchEndpoint", "value"],
  watch: {
    value: {
      handler(newVal) {
        console.log(newVal);
        if (!newVal) {
          this.selectedItem = null;
          return;
        }

        this.loading = true;
        api
          .request("GET", `${this.searchEndpoint}?withId=${newVal}`)
          .then(response => {
            if (response.data.items.length > 0) {
              this.selectedItem = response.data.items[0];
            }
            this.searchResult = response.data;
          })
          .finally(() => {
            this.loading = false;
          });
      },
      immediate: true
    },
    selectedItem(newVal) {
      this.$emit("change", newVal);
      if (newVal) {
        this.$emit("input", newVal[this.itemValue]);
      } else {
        this.$emit("input", null);
      }
    },
    searchFor(newVal) {
      this.loading = true;
      api
        .request("GET", `${this.searchEndpoint}?searchFor=${newVal}`)
        .then(response => {
          this.searchResult = response.data;
          console.log(response);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  methods: {
    clear() {
      this.searchFor = null;
      this.$refs.combobox.selectItem(null);
    }
  },
  data() {
    return {
      loading: false,
      searchFor: null,
      searchResult: {},
      selectedItem: null
    };
  }
};
</script>
